{
  "longPressMessage": "Potreban je duži pritisak za otvaranje pregleda"
}
